import React, { useMemo } from "react";
import "../activityPanel/ActivityPanel.scss";
import "../../../../components/typographyText/styles.scss";
import CustomEmpty from "../../../../components/customEmptyView/CustomEmpty";

export default function ActivityPanel({ activityData = [] }) {
  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} at ${formattedTime}`;
  };

  const groupActivities = (activities) => {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const startOfWeek = new Date();
    startOfWeek.setDate(today.getDate() - today.getDay());

    const grouped = {
      today: [],
      yesterday: [],
      thisWeek: [],
      past: [],
    };

    activities.forEach((activity) => {
      const activityDate = new Date(activity.activitydatetime);
      activity.formattedDateTime = formatDateTime(activity.activitydatetime);

      if (activityDate.toDateString() === today.toDateString()) {
        grouped.today.push(activity);
      } else if (activityDate.toDateString() === yesterday.toDateString()) {
        grouped.yesterday.push(activity);
      } else if (activityDate >= startOfWeek) {
        grouped.thisWeek.push(activity);
      } else {
        grouped.past.push(activity);
      }
    });

    return grouped;
  };

  const groupedActivities = useMemo(
    () => groupActivities(activityData),
    [activityData],
  );

  const renderActivityGroup = (groupTitle, activities) =>
    activities.length > 0 && (
      <div className="actMain">
        <div className="actHead detail-small-bold">{groupTitle}</div>
        {activities.map((activity, index) => (
          // <div className="actInfo" key={activity.transid}>
          //   <div className="actIndex detail-mid-light">{index + 1}.</div>
          //   <div className="actInnerInfo">
          <div className="actInfo" key={activity.transid}>
            <div className="timelineDot"></div>

            <div className="actInnerInfo">
              <div className="actDesc detail-mid-light">
                {activity.activity_message}
              </div>
              {activity.ticketstatus_name && (
                <div className="statusBadge">{activity.ticketstatus_name}</div>
              )}
              <div className="actDateDetail popup-sub-text">
                Created on {activity.formattedDateTime}, By{" "}
                {activity.activitydoneby}
              </div>
            </div>
          </div>
        ))}
      </div>
    );

  return !groupedActivities.today?.length &&
    !groupedActivities.yesterday?.length &&
    !groupedActivities.thisWeek?.length &&
    !groupedActivities.past?.length ? (
    <CustomEmpty moduleName="Activity" />
  ) : (
    <div className="activitySec">
      {groupedActivities.today?.length > 0 &&
        renderActivityGroup("Today", groupedActivities.today)}
      {groupedActivities.yesterday?.length > 0 &&
        renderActivityGroup("Yesterday", groupedActivities.yesterday)}
      {groupedActivities.thisWeek?.length > 0 &&
        renderActivityGroup("This Week", groupedActivities.thisWeek)}
      {groupedActivities.past?.length > 0 &&
        renderActivityGroup("Past Activities", groupedActivities.past)}
    </div>
  );
}
